export default "__VITE_ASSET__svbfs_zc__"